import {useEffect, useRef, useState} from 'react'

const REFRESH_INTERVAL = 100 // 100ms
const REFRESH_TIMEOUT = 5000 // 5 seconds

// Detect if the Osano cookie consent script is loaded.
// When the user access the website for the first time, the Osano script sometimes take some time to load and it's not detected
// which makes the cookie banner not to be displayed.
export const useOsanoDetection = () => {
  const [isLoaded, setIsLoaded] = useState<boolean | null>(false)
  const [isOpened, setIsOpened] = useState(false)

  const dialogRef = useRef<HTMLElement | null>(null)

  useEffect(() => {
    let interval = null
    let duration = 0

    // Osano sometimes takes some time to say if the cookie banner is opened or not.
    // This script keeps checking multiple times to make sure it gets the correct information.
    if (!isLoaded || !isOpened) {
      interval = setInterval(() => {
        if (window?.Osano?.cm) setIsLoaded(true)

        if (window.Osano?.cm?.dialogOpen) {
          setIsOpened(true)

          dialogRef.current = document?.querySelector(
            '.osano-cm-dialog'
          ) as HTMLElement
        }

        duration += REFRESH_INTERVAL
        if (duration >= REFRESH_TIMEOUT) {
          clearInterval(interval!)
        }
      }, REFRESH_INTERVAL)
    }

    return () => {
      if (interval) clearInterval(interval)
    }
  }, [isLoaded, isOpened])

  return {isLoaded, isOpened, dialogRef}
}
